import React from 'react';

const Synopsis = ({ content, onChange }) => {
  return (
    <div className="synopsis-container">
      <textarea
        className="form-control"
        value={content || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Write your story synopsis here..."
        rows={15}
        style={{ minHeight: '400px' }}
      />
    </div>
  );
};

export default Synopsis;
